// Load Testing (LT) Types

export type LTObjectType = string
export type LTStatus = 'Accepted' | 'Not Accepted'
export type LTMaterialType = string

export const LT_TEST_SITES = ['Bergen', 'Mongstad', 'Ågotnes'] as const
export type LTTestSite = (typeof LT_TEST_SITES)[number]
export const LT_DEFAULT_TEST_SITE: LTTestSite = 'Bergen'

export const LT_TEST_PROCEDURE_OPTIONS = [
  'STM - Load Testing',
  'STM Weight Procedure',
  'Hydraulic Jack',
] as const

export type LTTestProcedure = (typeof LT_TEST_PROCEDURE_OPTIONS)[number]

export const DEFAULT_LT_TEST_PROCEDURE: LTTestProcedure = 'STM - Load Testing'

export const LT_EQUIPMENT_OPTIONS = [
  'Hydraulic Jack',
  'DYNAFOR LLX 12.5t',
  'OSC 3t',
  'OSC 5t',
  'OSC-WZ 10t',
  'OSC 15t',
  'OSC-WZ 30t',
  'TEO 25000 SK 25t',
  'Scotland TEN 9628 5t',
  'Scotland TEN 9631 35t',
  'Mineea Co. LTD NMB CL 10t',
] as const

export type LTEquipmentType = (typeof LT_EQUIPMENT_OPTIONS)[number]

export interface LTEquipmentSettings {
  equipmentUsed: LTEquipmentType
  equipmentSerialNo: string
  lighting: string
}

export interface LTInspector {
  id: string
  first_name: string
  last_name: string
  certification_number?: string
  lt_level?: number
  user_id?: string
}

export interface LTCompany {
  id: string
  name: string
  report_code: string | null
}

export interface LTReportData {
  testDate: string
  testSite?: string
  reportNumber: string
  objects: string[]
  objectDescription: string
  issuedBy: string
  verifiedBy?: string
  status: LTStatus
  objectType: LTObjectType
  equipmentSettings: LTEquipmentSettings
  certificationNumber: string
  sequenceNumber: string
  extentOfExamination: string
  material: LTMaterialType
  testProcedure: LTTestProcedure | string
  testLoad?: string
  testDuration?: string
  comments?: string
  company?: string
  report_code?: string | null
  attachedImage?: string
  approvedBy?: string
  approvedAt?: string
}

export interface LTFormData {
  testDate: string
  testSite: string
  reportNumber: string
  objects: string[]
  objectDescription: string
  issuedBy: string
  verifiedBy?: string
  status: LTStatus
  objectType: LTObjectType
  equipmentSettings: LTEquipmentSettings
  extentOfExamination: string
  material: LTMaterialType
  testProcedure: LTTestProcedure
  testLoad: string
  testDuration: string
  comments?: string
  company?: string
  report_code?: string | null
  attachedImage?: string
}

export const DEFAULT_LT_EQUIPMENT: LTEquipmentSettings = {
  equipmentUsed: 'Hydraulic Jack',
  equipmentSerialNo: '',
  lighting: 'Standard Lighting',
}
